import axios from "axios";
import { getToken, removeToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { Notification, Message } from "element-ui";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 100000,
});
// 是否显示重新登录
export let isRelogin = { show: false };
// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // 是否需要设置 token
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
  instance.interceptors.response.use(
    function (res) {
      // 未设置状态码则默认成功状态
      const code = res.data.code || 200;
      const msg = res.data.msg || "";
      
      // Special case for SDS "not found" — treat as no data
      if (
        res.config.url?.includes("/jput/nomination/sdsFile/") &&
        msg === "No SDS file found for the given nomination ID."
      ) {
        return { data: [] }; // behave like empty result
      }
  
      // 二进制数据则直接返回
      if (
        res.request.responseType === "blob" ||
        res.request.responseType === "arraybuffer"
      ) {
        return res.data;
      }
  
      if (code === 401) {
        Message({ message: msg, type: "error", duration: 15000, showClose: true });
        if (location.pathname !== "/login") {
          location.href = "/login";
          sessionStorage.removeItem("pageStatus");
          sessionStorage.removeItem("editData");
          removeToken();
        }
      } else if (code === 500) {
        // Deactivated-account rejection pops in the top-right corner; the password-expired case is
        // handled by a modal on the login page (suppress the generic toast); other errors stay centred.
        if (msg && msg.toLowerCase().includes("deactivated")) {
          Notification.error({ title: msg, duration: 15000, showClose: true });
        } else if (msg && msg.toLowerCase().includes("password has expired")) {
          // no generic toast — the login page shows the "Password Expired" modal
        } else {
          Message({ message: msg, type: "error", duration: 15000, showClose: true });
        }
        return Promise.reject(new Error(msg));
      } else if (code !== 200 && code != 402) {
        Notification.error({ title: msg, duration: 15000, showClose: true });
        return Promise.reject("error");
      }
  
      return res.data;
    },
  
  function (error) {
    let { message } = error;
    if (message == "Network Error") {
      message = "Interface connection exception";
    } else if (message.includes("timeout")) {
      message = "Request timed out";
    } else if (message.includes("Request failed with status code")) {
      message = "interface" + message.substr(message.length - 3) + "error";
    } else if (message.includes("canceled")) {
      return Promise.reject(error);
    }
    Message({
      message: message,
      type: "error",
      duration: 15000,
      showClose: true,
    });
    return Promise.reject(error);
  }
);

export default instance;
